export const PROCESS_STEP_UPDATED = 'Process step updated 👍';
export const LOADING = 'Loading 🏃';
